// import { createI18n } from 'vue-i18n'
// // 框架 国际化文件
// const zh_cn = import.meta.glob('./lang/**/zh-CN.ts', { eager: true })
// const en = import.meta.glob('./lang/**/en.ts', { eager: true })

// // 加载 lang文件夹下的国际化
// export const loadLang = (modules: Record<string, any>) => {
//   const message: { [key: string]: string } = {}

//   Object.keys(modules).forEach((module) => {
//     Object.assign(message, { ...modules[module].default })
//   })
//   return message
// }
// export const messages: { [key: string]: any } = {
//   'zh-CN': {
//     langName: '简体中文',
//     ...loadLang(zh_cn)
//   },
//   en: {
//     langName: 'English',
//     ...loadLang(en)
//   }
// }

// // 返回当前language
// function getLanguage() {
//   // 默认语言为英文
//   return localStorage.getItem('lang') || 'en'
// }

// export const i18n = createI18n({
//   locale: getLanguage(),
//   // 需要使用组合式api需要设置
//   legacy: false,
//   messages
// })
import { createI18n } from 'vue-i18n';
import en from './lang/en.json';
import zh from './lang/zh.json';

const messages = {
  en,
  zh,
};

// 获取初始语言设置：URL参数 > localStorage > 默认值
const getInitialLocale = () => {
  // 从URL参数获取
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('lang');

  if (urlLang && ['zh', 'en'].includes(urlLang)) {
    return urlLang;
  }

  // 从localStorage获取
  const savedLang = localStorage.getItem('locale');
  if (savedLang && ['zh', 'en'].includes(savedLang)) {
    return savedLang;
  }

  // 默认语言
  return 'zh';
};
const i18n = createI18n({
  locale: getInitialLocale() || 'zh',
  fallbackLocale: 'zh',
  messages,
});

export default i18n;